import React from "react"
import { concatStrings, retrieveItemImageFromHero } from "../utilities"
import DfbHeadline from "../ui-kit/dfb_headline"
import DfbAnchor from "../ui-kit/dfb_anchor"
import DfbImage from "../ui-kit/dfb_image"
import DfbRte from "../ui-kit/dfb_rte"
import PageContext from "../page-context"
import { t } from "../../i18n-utility"
import DateFormat from "../date_format"
import { isPageAccessRestricted } from "../../helper/pageAccess.mjs"
import { Transformation } from "cloudinary-react"
import DfbSymbol from "../ui-kit/dfb_symbol"
import { withPrefix } from "gatsby"

const CHighlightArticles = ({ data, add_class }) => {
  const baseClass = "c-HighlightArticles"
  const { title, icons, collection, description } = data

  const list = retrieveItemImageFromHero(collection, "")

  return (
    <div className={concatStrings(baseClass, add_class)}>
      {title && title.length && title.length > 0 && (
        <DfbHeadline
          headline={title}
          headline_level="h6"
          add_class={`${baseClass}-title`}
        />
      )}
      {description && description.length && description.length > 0 && (
        <>
          <DfbRte text={description} />
          <br />
        </>
      )}
      {icons && !!icons.length && (
        <div className={`${baseClass}-icons dfb-Card-icons`}>
          {icons.map((icon) => (
            <div className="dfb-Card-icon" key={`icon${icon}`}>
              <DfbSymbol icon_type={icon} />
            </div>
          ))}
        </div>
      )}

      <ul className={`${baseClass}-list`}>
        {list.map((item) => (
          <li className={`${baseClass}-item`} key={item.uid}>
            <a
              href={withPrefix(item.full_slug)}
              className="c-HighlightArticles-link"
            >
              <div className={`${baseClass}-content`}>
                <div className={`${baseClass}-text`}>
                  <PageContext.Consumer>
                    {({ translations }) => (
                      <div className={`${baseClass}-category`}>
                        {item.content.card_format_override &&
                        item.content.card_format_override !== ""
                          ? item.content.card_format_override
                          : t(translations, `cards.${item.type}`)}
                        {(item.type === "news" ||
                          item.type === "trainercolumn") && (
                          <DateFormat
                            singledate={item.starttime}
                            format="DD.MM.YYYY"
                          />
                        )}
                      </div>
                    )}
                  </PageContext.Consumer>

                  <DfbHeadline
                    headline={item.content.title}
                    headline_level="h4"
                    add_class={`${baseClass}-headline`}
                  />
                  <PageContext.Consumer>
                    {({ translations }) => (
                      <DfbAnchor
                        text={t(translations, "dfb_anchor.morelink")}
                        tagName="div"
                        secondary={true}
                        add_class={`${baseClass}-anchor`}
                        locked={isPageAccessRestricted(item)}
                      />
                    )}
                  </PageContext.Consumer>
                </div>

                {item.content.titleimage && (
                  <div className={`${baseClass}-image`}>
                    <DfbImage
                      image={
                        typeof item.content.titleimage === "string" &&
                        item.content.titleimage !== ""
                          ? { src: item.content.titleimage }
                          : item.content.titleimage
                      }
                      aspect_ratio="1:1"
                    >
                      <Transformation
                        crop="fill"
                        gravity="faces:center"
                        width="150"
                        height="150"
                        quality="auto"
                        fetchFormat="auto"
                      />
                    </DfbImage>
                  </div>
                )}
              </div>
            </a>
          </li>
        ))}
      </ul>
    </div>
  )
}

export default CHighlightArticles
